import React from 'react';

export const VolLocNameModal = {
  title: 'Volcano Name',
  body: (
    <div>
      <p>
        The name of the volcano as listed by the Smithsonian Institution, Global Volcanism Program. More information is available about this volcano at the
        {' '}
        <a href="http://www.volcano.si.edu" target="_blank" rel="noopener noreferrer">{'Global Volcanism Program\'s'}</a>
        {' '}
        website.
      </p>
    </div>
  ),
};
